

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    progressData: null,
    requiredFields: [],
    completionPercentage: 0,
    round_id: null
}

const progressReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PROGRESS_DATA:
            return {
                ...state,
                progressData: action?.progressData,
                requiredFields: action?.requiredFields,
                completionPercentage: action?.completionPercentage,
                round_id: action?.round_id,
            }
        default:
            return state;
    }
}

export default progressReducer
